<div class="title">{{ data.addressType }}</div>
<div>{{ data.companyName }}</div>
<div>{{ data.contacts }}</div>
<div>{{ data.street}} {{ data.no }}</div>
<div>{{ data.zip}}  {{ data.place }}</div>
<div>{{ data.country }}</div>
